/* eslint-disable no-console */
import MapDraw from 'map/MapDraw';

// map : 다비오 지도 API 에 접근할 수 있는 class
export const validMap = () => {
  if (!MapDraw.map) {
    return console.warn('Map is not available');
  }
};

// mapData : map을 보여주기 전 사용자가 데이터의 정보를 찾아볼 수 있는 class
export const validMapData = () => {
  if (!MapDraw.mapData) {
    return console.warn('MapData is not available');
  }
};
